@if (screenInfo$ | async; as screen) {
  <div style="display: flex; flex-direction: column; height: 100%">
    @if (isLoading) {
      <div
        style="flex: 1 0 100%; min-height: 0; display: flex; flex-direction: column; justify-content: space-between;">
        @if (selectedWidget === 'instrument' || selectedWidget === 'service-history') {
          <sh-tabs id="psm-details-tabs-1" style="width: 43%" condensed [collapsed]="screen.size === 'XSmall' || screen.size === 'Small' || screen.size === 'Medium'"
            >
            @for (tab of displayedTabs; track tab.name) {
              <sh-tab-item id="psm-details-tab-item-2" disabled [active]="activeTab === tab.name"
              (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
            }
          </sh-tabs>
        }
        <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
          <sh-spinner id="psm-details-spinner-3" site="s"></sh-spinner>
        </div>
      </div>
    }
    @if (!isLoading) {
      <div style="flex: 1; min-height: 0;">
        <p-table [size]="'small'" #table [value]="psms" [scrollable]="true" scrollHeight="flex" dataKey="Id"
          [expandedRowKeys]="expandedRows" [customSort]="true" (sortFunction)="customSort($event)"
          [sortField]="'target'" [sortOrder]="1">
          <!-- Tools -->
          <ng-template #caption style="border: none;">
            <div style="display: flex; align-items: center; gap: 64px;">
              @if (selectedWidget === 'instrument' || selectedWidget === 'service-history') {
                <sh-tabs id="psm-details-tabs-4" style="flex: 1 1 43%;" condensed [collapsed]="screen.size === 'XSmall' || screen.size === 'Small' || screen.size === 'Medium'"
                  >
                  @for (tab of displayedTabs; track tab.name) {
                    <sh-tab-item id="psm-details-tab-item-5" [active]="activeTab === tab.name"
                    (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
                  }
                </sh-tabs>
              }
              <div class="table-tools" style="flex: 1 1 57%; gap: 8px; align-items: center;">
                <sh-dropdown id="psm-details-dropdown-6" no-border condensed style="min-width: 100px; max-width: 140px;" [attr.value]="(selectedRange === 30 ? 'psmDetails.range.30days' : selectedRange === 60 ? 'psmDetails.range.60days' : selectedRange === 90 ? 'psmDetails.range.90days' : selectedRange === 120 ? 'psmDetails.range.120days' : 'psmDetails.range.120days') | transloco">
                  <sh-menu-item id="psm-details-menu-item-30-days" (click)="changeRange(30,'serviceHistory')" [attr.label]="'psmDetails.range.30days' | transloco"
                  [active]="selectedRange === 30"></sh-menu-item>
                  <sh-menu-item id="psm-details-menu-item-60-days" (click)="changeRange(60,'serviceHistory')" [attr.label]="'psmDetails.range.60days' | transloco"
                  [active]="selectedRange === 60"></sh-menu-item>
                  <sh-menu-item id="psm-details-menu-item-90-days" (click)="changeRange(90,'serviceHistory')" [attr.label]="'psmDetails.range.90days' | transloco"
                  [active]="selectedRange === 90"></sh-menu-item>
                  <sh-menu-item id="psm-details-menu-item-120-days" (click)="changeRange(120,'serviceHistory')" [attr.label]="'psmDetails.range.120days' | transloco"
                  [active]="selectedRange === 120"></sh-menu-item>
                 
                </sh-dropdown>
                <p-columnFilter style="flex: 0 1 210px;" type="text" [showMenu]="false" field="pattern_name"
                  matchMode="contains">
                  <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                    <sh-search id="psm-details-search-search-for-pattern-name" no-border [attr.label]="'psmDetails.filter.searchForPatternName' | transloco" condensed [(ngModel)]="searchTerm"
                    (ngModelChange)="filter($event)"></sh-search>
                  </ng-template>
                </p-columnFilter>
                <sh-divider id="psm-details-divider-12" spacing='s' style="height: 30px;" vertical></sh-divider>
                <sh-icon id="psm-details-icon-13" button icon='refresh' size="s" (click)="refresh()"></sh-icon>
                @if (workareaSize !== 'fullscreen') {
                  <sh-icon id="psm-details-icon-14" size="xs" [icon]="workareaSize === 'medium' ? 'arrow-face-up-l' : 'arrow-face-down-l'"
                  button (click)="onMaximize()" [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                }
                <sh-icon id="psm-details-icon-expand" size="s" [icon]="workareaSize === 'fullscreen' ? 'split-vertically' : 'maximize'" button (click)="onExpand($event)"></sh-icon>
                <sh-icon id="psm-details-icon-cancel" icon="cancel" size="s" button (click)="onMinimize()"
                [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
              </div>
            </div>
          </ng-template>
          <!-- Header -->
          <ng-template #header>
            <tr>
              <th pSortableColumn="id" style="min-width:150px;" pFrozenColumn>
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'psmDetails.table.alertId' | transloco }}
                  <p-sortIcon field="id" />
                </div>
              </th>
              @if (!isDeviceUI) {
                <th pSortableColumn="serial" style="min-width:150px;">
                  <div style="display: flex; gap: 6px; align-items: center;">
                    {{ 'psmDetails.table.serialNumber' | transloco }}
                    <p-sortIcon field="serial" />
                  </div>
                </th>
              }
              <th pSortableColumn="status" style="min-width:125px;">
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'psmDetails.table.status' | transloco }}
                  <p-sortIcon field="status" />
                </div>
              </th>
              <th pSortableColumn="target" style="min-width:125px;">
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'psmDetails.table.targetDate' | transloco }}
                  <p-sortIcon field="target" />
                </div>
              </th>
              <th pSortableColumn="score" style="min-width:125px;">
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'psmDetails.table.scoreDate' | transloco }}
                  <p-sortIcon field="score" />
                </div>
              </th>
              <th pSortableColumn="code" style="min-width:150px;">
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'psmDetails.table.patternCode' | transloco }}
                  <p-sortIcon field="code" />
                </div>
              </th>
              <th pSortableColumn="name" style="min-width:175px;">
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'psmDetails.table.patternName' | transloco }}
                  <p-sortIcon field="name" />
                </div>
              </th>
              <th pSortableColumn="notificationid" style="min-width:175px;">
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'psmDetails.table.notificationId' | transloco }}
                  <p-sortIcon field="notificationid" />
                </div>
              </th>
              <th pSortableColumn="peakticketid" style="min-width:150px;">
                <div style="display: flex; gap: 2px; align-items: center;">
                  {{ 'psmDetails.table.peakTicketId' | transloco }}
                  <p-sortIcon field="peakticketid" />
                </div>
              </th>
              <th style="min-width:175px;">
                <div style="display: flex; gap: 2px; align-items: center;">
                  {{ 'psmDetails.table.assignedToCse' | transloco }}
                </div>
              </th>
              <th alignFrozen="right" pFrozenColumn>{{ 'psmDetails.table.actions' | transloco }}</th>
            </tr>
          </ng-template>
          <ng-template #body let-psm let-expanded="expanded">
            <tr>
              <td pFrozenColumn>
                <div style="display: flex; gap: 8px; align-items: center;">
                  <sh-icon id="psm-details-icon-warning" icon="warning" size="xs" color="#FBBF28"></sh-icon>
                  <span>{{psm.id}}</span>
                </div>
              </td>
              @if (!isDeviceUI) {
                <td>{{psm.serial}}</td>
              }
              <td>{{psm.status}}</td>
              <td>{{psm.target_date}}</td>
              <td>{{psm.score_date}}</td>
              <td>{{psm.pattern_code}}</td>
              <td><span [innerHTML]="highlight(psm.pattern_name)"></span></td>
              <td>{{psm.notification_id}}</td>
              <td>{{psm.peak_ticket_id}}</td>
              <td>
                @if (psm.is_assigned_to_cse) {
                  <sh-icon id="psm-details-icon-success" size="xs" icon="success"></sh-icon>
                }
                @if (!psm.is_assigned_to_cse) {
                  <span>-</span>
                }
              </td>
              <td alignFrozen="right" pFrozenColumn>
                <div style="display: flex; gap: 6px; justify-content: center;">
                  <!-- <sh-button id="psm-details-button-help" icon-position="left" icon="url('/assets/images/generate.svg')"
                  [ngClass]="'magic-button'" *ngIf="service.Status === 'Open'" compact label="Help"
                color="tertiary" (click)="askChat(service.Id)"></sh-button> -->
                <!-- <sh-button id="psm-details-button-details" size="auto" [icon]="expanded ? 'arrow-line-up-s' : 'arrow-line-down-s'"
                icon-position="left" compact label="Details" [pRowToggler]="service"
              color="tertiary"></sh-button> -->
              <!-- <sh-icon id="psm-details-icon-show" icon="show" size="s" button (click)="openPSMDetails(psm.id)"></sh-icon> -->
              <sh-button id="psm-details-button-details" compact color="tertiary" [attr.label]="'psmDetails.button.details' | transloco"
              (click)="openPSMDetails(psm.pattern_id)"></sh-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="10">
            @if (!isError) {
              <div
                style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                <sh-icon id="psm-details-icon-warning" icon="warning" size="s"></sh-icon>
                <span>{{ 'common.empty.noData' | transloco }}</span>
              </div>
            }
            @if (isError) {
              <div
                style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                <sh-icon id="psm-details-icon-error" icon="error" size="s"></sh-icon>
                <span>{{ 'common.empty.error' | transloco }}</span>
              </div>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}
</div>
}